(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-avis-clients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hb-reviews-carousel')) {
    class HbReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        if (!this.viewport || !this.track) return;
        this.originals = Array.from(this.track.querySelectorAll('[data-card]'));
        if (!this.originals.length) return;

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.speed = parseFloat(this.dataset.speed) || 24;
        this.x = 0;
        this.setW = 0;
        this.hover = false;
        this.focusInside = false;
        this.dragging = false;
        this.anim = null;
        this.resumeAt = 0;

        this.setupMore();
        this.bind();
        this.layout();
        this.last = performance.now();
        this.tick = this.tick.bind(this);
        this.raf = requestAnimationFrame(this.tick);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        if (this.ro) this.ro.disconnect();
      }

      setupMore() {
        this.originals.forEach((card) => this.prepareMore(card));
      }

      prepareMore(card) {
        const text = card.querySelector('[data-text]');
        const btn = card.querySelector('[data-more]');
        if (!text || !btn) return;
        const label = btn.querySelector('[data-more-label]');
        const needs = card.classList.contains('is-expanded') || text.scrollHeight > text.clientHeight + 2;
        btn.hidden = !needs;
        if (btn.dataset.bound) return;
        btn.dataset.bound = '1';
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const open = !card.classList.contains('is-expanded');
          card.classList.toggle('is-expanded', open);
          btn.setAttribute('aria-expanded', String(open));
          if (label) label.textContent = open ? 'Réduire' : 'Lire l’avis complet';
        });
      }

      bind() {
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.hover = true;
        });
        this.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') this.hover = false;
        });
        this.addEventListener('focusin', (e) => {
          this.focusInside = true;
          const card = e.target.closest('[data-card]');
          if (card && !this.static) this.reveal(card);
        });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            this.focusInside = this.contains(document.activeElement);
          });
        });

        this.querySelector('[data-prev]').addEventListener('click', () => this.step(-1));
        this.querySelector('[data-next]').addEventListener('click', () => this.step(1));

        let startX = 0;
        let startY = 0;
        let baseX = 0;
        let moved = false;
        let pid = null;
        this.viewport.addEventListener('pointerdown', (e) => {
          if (this.static || e.button > 0) return;
          if (e.target.closest('button')) return;
          pid = e.pointerId;
          startX = e.clientX;
          startY = e.clientY;
          baseX = this.x;
          moved = false;
          this.anim = null;
          this.dragging = true;
        });
        this.viewport.addEventListener('pointermove', (e) => {
          if (!this.dragging || e.pointerId !== pid) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          if (!moved) {
            if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {
              this.dragging = false;
              return;
            }
            if (Math.abs(dx) < 6) return;
            moved = true;
            this.viewport.classList.add('is-dragging');
            try { this.viewport.setPointerCapture(pid); } catch (err) {}
          }
          this.x = baseX - dx;
          this.render();
        });
        const end = (e) => {
          if (e.pointerId !== pid) return;
          this.dragging = false;
          this.viewport.classList.remove('is-dragging');
          this.resumeAt = performance.now() + 2500;
          if (moved) {
            const block = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
            this.viewport.addEventListener('click', block, { capture: true, once: true });
            setTimeout(() => this.viewport.removeEventListener('click', block, { capture: true }), 50);
          }
          pid = null;
        };
        this.viewport.addEventListener('pointerup', end);
        this.viewport.addEventListener('pointercancel', end);
        this.viewport.addEventListener('dragstart', (e) => e.preventDefault());

        this.ro = new ResizeObserver(() => this.layout());
        this.ro.observe(this.viewport);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.layout());
        this.reduced.addEventListener?.('change', () => this.layout());
      }

      gap() {
        return parseFloat(getComputedStyle(this.track).columnGap) || 0;
      }

      layout() {
        this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());
        this.originals.forEach((card) => this.prepareMore(card));
        const gap = this.gap();
        const vw = this.viewport.clientWidth;
        const cardW = this.originals[0].getBoundingClientRect().width;
        const setW = this.originals.reduce((s, c) => s + c.getBoundingClientRect().width, 0) + gap * this.originals.length;
        this.cardStep = cardW + gap;
        this.static = this.reduced.matches ? setW - gap <= vw : setW < vw + cardW;
        this.classList.toggle('is-static', this.static);
        if (this.static) {
          this.x = 0;
          this.track.style.transform = '';
          return;
        }
        this.setW = setW;
        const copies = Math.ceil((vw + cardW) / setW) + 1;
        for (let i = 0; i < copies; i++) {
          this.originals.forEach((card) => {
            const c = card.cloneNode(true);
            c.setAttribute('data-clone', '');
            c.setAttribute('aria-hidden', 'true');
            c.setAttribute('inert', '');
            c.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
            c.querySelectorAll('[aria-controls]').forEach((n) => n.removeAttribute('aria-controls'));
            this.track.appendChild(c);
          });
        }
        this.render();
      }

      wrap(v) {
        if (!this.setW) return v;
        return ((v % this.setW) + this.setW) % this.setW;
      }

      render() {
        if (this.static) return;
        this.x = this.wrap(this.x);
        this.track.style.transform = 'translate3d(' + (-this.x).toFixed(2) + 'px,0,0)';
      }

      paused() {
        return this.hover || this.focusInside || this.dragging || performance.now() < this.resumeAt || this.reduced.matches;
      }

      tick(now) {
        const dt = Math.min(0.05, (now - this.last) / 1000);
        this.last = now;
        if (!this.static) {
          if (this.anim) {
            const t = Math.min(1, (now - this.anim.t0) / this.anim.dur);
            const e = 1 - Math.pow(1 - t, 3);
            this.x = this.anim.from + (this.anim.to - this.anim.from) * e;
            this.render();
            if (t >= 1) this.anim = null;
          } else if (!this.paused()) {
            this.x += this.speed * dt;
            this.render();
          }
        }
        this.raf = requestAnimationFrame(this.tick);
      }

      step(dir) {
        if (this.static) return;
        const target = this.x + dir * this.cardStep;
        this.resumeAt = performance.now() + 3000;
        if (this.reduced.matches) {
          this.x = target;
          this.render();
          return;
        }
        this.anim = { from: this.x, to: target, t0: performance.now(), dur: 520 };
      }

      reveal(card) {
        const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const target = card.offsetLeft - pad - (this.viewport.clientWidth - card.offsetWidth) / 2 + pad;
        this.anim = null;
        this.x = target;
        this.render();
      }
    }
    customElements.define('hb-reviews-carousel', HbReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hb-accordion')) {
    class HbAccordion extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('.hbf-item__trigger'));
        this.triggers.forEach((btn) => {
          btn.addEventListener('click', () => this.toggle(btn));
          btn.addEventListener('keydown', (e) => this.onKey(e, btn));
        });
      }

      panelOf(btn) {
        return document.getElementById(btn.getAttribute('aria-controls'));
      }

      open(btn) {
        const item = btn.closest('.hbf-item');
        const panel = this.panelOf(btn);
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => requestAnimationFrame(() => item.classList.add('is-open')));
      }

      close(btn) {
        const item = btn.closest('.hbf-item');
        const panel = this.panelOf(btn);
        btn.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-open');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) {
          panel.hidden = true;
          return;
        }
        const done = (e) => {
          if (e && e.target !== panel) return;
          panel.removeEventListener('transitionend', done);
          clearTimeout(timer);
          if (btn.getAttribute('aria-expanded') === 'false') panel.hidden = true;
        };
        const timer = setTimeout(done, 450);
        panel.addEventListener('transitionend', done);
      }

      toggle(btn) {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        this.triggers.forEach((other) => {
          if (other !== btn && other.getAttribute('aria-expanded') === 'true') this.close(other);
        });
        if (isOpen) this.close(btn);
        else this.open(btn);
      }

      onKey(e, btn) {
        const i = this.triggers.indexOf(btn);
        let next = null;
        if (e.key === 'ArrowDown') next = this.triggers[(i + 1) % this.triggers.length];
        else if (e.key === 'ArrowUp') next = this.triggers[(i - 1 + this.triggers.length) % this.triggers.length];
        else if (e.key === 'Home') next = this.triggers[0];
        else if (e.key === 'End') next = this.triggers[this.triggers.length - 1];
        if (next) {
          e.preventDefault();
          next.focus();
        }
      }
    }
    customElements.define('hb-accordion', HbAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-hero-horloger"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hb-marquee')) {
  class HbMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hb-marquee__track');
      this.groups = Array.from(this.querySelectorAll('.hb-marquee__group'));
      if (!this.track || this.groups.length < 2) return;
      this.speed = parseFloat(this.dataset.speed) || 40;
      this.base = Array.from(this.groups[0].querySelectorAll('[data-seq]')).map((n) => n.cloneNode(true));
      this.lastDuration = 0;
      this.update = this.update.bind(this);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.update);
      this.update();
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
    update() {
      const viewport = this.clientWidth;
      if (!viewport || !this.base.length) return;
      const first = this.groups[0];
      let guard = 0;
      while (first.getBoundingClientRect().width < viewport + 2 && guard < 20) {
        this.groups.forEach((group) => {
          this.base.forEach((node) => {
            const clone = node.cloneNode(true);
            clone.removeAttribute('data-seq');
            clone.setAttribute('aria-hidden', 'true');
            group.appendChild(clone);
          });
        });
        guard++;
      }
      const width = first.getBoundingClientRect().width;
      const duration = width / this.speed;
      if (Math.abs(duration - this.lastDuration) > 0.25) {
        this.lastDuration = duration;
        this.track.style.setProperty('--hb-marquee-duration', duration.toFixed(2) + 's');
      }
    }
  }
  customElements.define('hb-marquee', HbMarquee);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-incontournables"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hb-carousel')) {
    class HbCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hbi-track');
        this.prev = this.querySelector('.hbi-arrow--prev');
        this.next = this.querySelector('.hbi-arrow--next');
        if (!this.track) return;
        this.onScroll = this.update.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.track);
        this.prev && this.prev.addEventListener('click', () => this.go(-1));
        this.next && this.next.addEventListener('click', () => this.go(1));
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.ro) this.ro.disconnect();
      }

      step() {
        const card = this.track.querySelector('.hbi-card');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const x = this.track.scrollLeft;
        if (this.prev) this.prev.disabled = x <= 4;
        if (this.next) this.next.disabled = x >= max - 4;
      }
    }
    customElements.define('hb-carousel', HbCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hdc-avant-apres"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hdc-before-after')) {
  class HdcBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.hdc-ba__range');
      if (!this.range) return;
      const set = (v) => this.style.setProperty('--pos', v + '%');
      this.range.addEventListener('input', () => set(this.range.value));
      const fromPointer = (e) => {
        const r = this.getBoundingClientRect();
        const x = Math.min(Math.max(e.clientX - r.left, 0), r.width);
        const v = (x / r.width) * 100;
        this.range.value = v;
        set(v);
      };
      this.addEventListener('pointerdown', (e) => { this.dragging = true; fromPointer(e); });
      this.addEventListener('dragstart', (e) => e.preventDefault());
      window.addEventListener('pointermove', (e) => { if (this.dragging) fromPointer(e); });
      window.addEventListener('pointerup', () => { this.dragging = false; });
    }
  }
  customElements.define('hdc-before-after', HdcBeforeAfter);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hdc-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hdc-faq-list')) {
  class HdcFaqList extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelectorAll('.hdc-faq__item').forEach((item) => {
        const summary = item.querySelector('summary');
        const panel = item.querySelector('.hdc-faq__a');
        if (!summary || !panel) return;
        summary.addEventListener('click', (e) => {
          if (this.reduce || !panel.animate) return;
          e.preventDefault();
          if (item.dataset.busy) return;
          item.dataset.busy = '1';
          const done = () => { panel.style.height = ''; delete item.dataset.busy; };
          if (item.open) {
            const a = panel.animate([{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'ease' });
            a.onfinish = () => { item.open = false; done(); };
          } else {
            item.open = true;
            const h = panel.offsetHeight;
            const a = panel.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 300, easing: 'ease' });
            a.onfinish = done;
          }
        });
      });
      this.addEventListener('click', (e) => {
        const link = e.target.closest('a[href="#guide-des-tailles"]');
        if (!link) return;
        const target = document.getElementById('guide-des-tailles') || document.querySelector('.hdc-sg-section, .hdc-sg');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: this.reduce ? 'auto' : 'smooth', block: 'start' });
        const range = target.querySelector('input[type="range"]');
        if (range) setTimeout(() => range.focus({ preventScroll: true }), this.reduce ? 0 : 600);
      });
    }
  }
  customElements.define('hdc-faq-list', HdcFaqList);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hdc-guide-tailles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hdc-size-guide')) {
  class HdcSizeGuide extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.hdc-sg__range');
      this.areaEl = this.querySelector('[data-area]');
      this.resultEl = this.querySelector('[data-result]');
      if (!this.range || this.ready) return;
      this.ready = true;
      const d = this.dataset;
      this.min = Number(d.min);
      this.max = Number(d.max);
      this.bounds = [Number(d.max1), Number(d.max2), Number(d.max3)];
      this.labels = [d.label1, d.label2, d.label3, d.label4];
      this.resultText = (this.querySelector('.hdc-sg__result-label') || {}).textContent || '';
      this.current = this.resultEl ? this.resultEl.textContent : '';
      this.range.addEventListener('input', () => this.update());
      this.update(true);
    }
    labelFor(v) {
      for (let i = 0; i < this.bounds.length; i++) {
        if (v <= this.bounds[i]) return this.labels[i];
      }
      return this.labels[3];
    }
    update(initial) {
      const v = Math.round(Number(this.range.value));
      const p = (v - this.min) / (this.max - this.min);
      this.style.setProperty('--p', p);
      if (this.areaEl) this.areaEl.textContent = v;
      const label = this.labelFor(v);
      this.range.setAttribute('aria-valuetext', v + ' m², ' + this.resultText.trim() + ' ' + label);
      if (this.resultEl && label !== this.current) {
        this.current = label;
        this.resultEl.textContent = label;
        if (!initial) {
          this.resultEl.classList.remove('is-changing');
          void this.resultEl.offsetWidth;
          this.resultEl.classList.add('is-changing');
        }
      }
    }
  }
  customElements.define('hdc-size-guide', HdcSizeGuide);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hdc-promo-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hdc-promo-bar')) {
  class HdcPromoBar extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end || '');
      if (!Number.isNaN(end) && Date.now() > end) {
        this.hidden = true;
        return;
      }
      const units = {};
      this.querySelectorAll('[data-u]').forEach((el) => { units[el.dataset.u] = el; });
      if (units.s && !Number.isNaN(end)) {
        const pad = (n) => String(n).padStart(2, '0');
        const tick = () => {
          const left = Math.floor((end - Date.now()) / 1000);
          if (left <= 0) {
            this.hidden = true;
            clearInterval(this._timer);
            return;
          }
          units.d.textContent = Math.floor(left / 86400);
          units.h.textContent = pad(Math.floor((left % 86400) / 3600));
          units.m.textContent = pad(Math.floor((left % 3600) / 60));
          units.s.textContent = pad(left % 60);
        };
        tick();
        clearInterval(this._timer);
        this._timer = setInterval(tick, 1000);
      }
      const btn = this.querySelector('.hdc-promo__code');
      const status = this.querySelector('[role="status"]');
      if (!btn) return;
      btn.addEventListener('click', async () => {
        const code = btn.dataset.code || '';
        let ok = false;
        try {
          await navigator.clipboard.writeText(code);
          ok = true;
        } catch (e) {
          const t = document.createElement('textarea');
          t.value = code;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
          t.remove();
        }
        if (!ok) return;
        btn.classList.add('is-copied');
        if (status) status.textContent = 'Code ' + code + ' copié';
        clearTimeout(this._t);
        this._t = setTimeout(() => {
          btn.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 1800);
      });
    }
  }
  HdcPromoBar.prototype.disconnectedCallback = function () {
    clearInterval(this._timer);
  };
  customElements.define('hdc-promo-bar', HdcPromoBar);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
